import { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

export default function DashboardLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <CssBaseline />

      <Navbar onMenuClick={() => setMobileOpen(!mobileOpen)} />

      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <Box
        component="main"
        id="main-content"
        sx={{ flexGrow: 1, p: 3, overflowY: "auto", mt: 6 }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
